

    require('../../model/Component').registerSubTypeDefaulter('timeline', function () {
        // Only slider now.
        return 'slider';
    });




//////////////////
// WEBPACK FOOTER
// ./~/echarts/lib/component/timeline/typeDefaulter.js
// module id = od06
// module chunks = 5